import { useEffect, useRef, useState } from 'react'
import { ChevronDownIcon } from '@heroicons/react/24/outline'
import { Button } from 'components/ui/button'

interface Option {
  value: string
  label: string
}

interface SingleSelectProps {
  label?: string
  value: string
  options: Option[]
  placeholder?: string
  onChange: (value: any) => void
  disabled?: boolean
}

export const SingleSelect = ({
  label,
  value,
  options,
  placeholder = 'Select an option',
  onChange,
  disabled
}: SingleSelectProps) => {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

  const selectedLabel =
    options.find(opt => opt.value === value)?.label || ''

  return (
    <div ref={ref} className="relative w-full">
      {label && (<h6>label</h6>)}
      {/* Control */}
      <Button
        type="button"
        color="blue-accent"
        onClick={() => setOpen(!open)}
        disabled={disabled}
        className='w-full text-left'
      >
        <span className={selectedLabel ? '' : '' }>
          {selectedLabel || placeholder}
        </span>
        <ChevronDownIcon
          className={`h-4 w-4 transition ${open ? 'rotate-180' : ''}`}
        />
      </Button>

      {/* Dropdown */}
      {open && (
        <ul className="
          absolute z-50 mt-1 max-h-60 w-full overflow-auto
          rounded-md border border-gray-200 bg-white shadow-lg
        ">
          {options?.length === 0 && (
            <li className="px-3 py-2 text-sm text-gray-500">
              No options
            </li>
          )}

          {options?.map(opt => (
            <li
              key={opt.value}
              onClick={() => {
                onChange(opt)
                setOpen(false)
              }}
              className={`
                cursor-pointer px-3 py-2 text-sm
                hover:bg-blue-50 text-left
                ${opt.value === value ? 'bg-blue-100 font-medium' : ''}
              `}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
